<section class="activation-shell">
    <div class="activation-card">
        <p class="activation-eyebrow">Capvizon</p>
        <h1>Account reactivation</h1>
        <p
            class="activation-copy"
            *ngIf="(requestStatus$ | async) === httpRequestStatus.In_progress">
            We are validating your reactivation link and restoring your account.
        </p>
        <p
            class="activation-copy"
            *ngIf="(requestStatus$ | async) === httpRequestStatus.Success">
            {{ (response$ | async)?.message }}
        </p>
        <p
            class="activation-copy activation-copy--error"
            *ngIf="(requestStatus$ | async) === httpRequestStatus.Failed">
            {{ errorMessage$ | async }}
        </p>
        <div
            class="activation-actions"
            *ngIf="(requestStatus$ | async) !== httpRequestStatus.In_progress">
            <button
                type="button"
                class="activation-button"
                (click)="navigateToLandingPage()">
                Go to sign in
            </button>
        </div>
    </div>
</section>
